import { Box, Heading } from "@chakra-ui/react"

const SectionHeading: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box>
    <Heading size="sm" color="gray.700" mb={3}>{children}</Heading>
    <Box borderBottom="1px solid" borderColor="gray.200" mb={4} />
  </Box>
)

export default SectionHeading
